<template>
    <div>

        <v-form name="editForm" ref="editForm">

            <h4 class="tw-text-secondary mt-3 mb-3">Wallet Card</h4>

            <div class="tw-flex tw-flex-col tw-gap-4 tw-p-1">
                <div class="tw-flex tw-flex-col md:tw-flex-row tw-gap-4">
                    <div class="tw-flex-grow">

                        <v-file-input
                            v-model="modelObject.document"
                            label="wallet-card.pdf"
                            accept="application/pdf, application/msword"
                            dense
                            outlined
                            hide-details
                            class="mb-4"
                        >
                        </v-file-input>

                        <p>Valid formats: *.PDF or *.DOC</p>

                    </div>
                </div>
            </div>

            <div class="tw-flex tw-justify-end">
                <v-btn :loading="saveLoading" :disabled="isEmptyUpload" class="main-btn" @click="uploadFiles">Upload</v-btn>
            </div>

        </v-form>
    </div>

</template>

<script>

export default {
    name: "WebsiteContentWalletCard",
    components: {
        //
    },
    props: {
        'constants': {
            type: Object,
            required: false,
            default: function () {
                return undefined
            }
        },

    },
    data() {
        return {
            show_content1_dialog: false,
            show_content2_dialog: false,
            modelObject: {},
            saveLoading: false,
        }
    },
    mounted() {
        //
    },
    computed: {
        isEmptyUpload() {
            //return Object.keys(this.modelObject).length === 0
            return !Object.values(this.modelObject).some(value => value !== null);
        }
    },
    methods: {
        emptyUpload() {
            for (let key in this.modelObject) {
                this.modelObject[key] = null
            }
        },
        editContentModal(editor) {
            this[editor] = true
        },
        updateContent(content, ref) {
            if (!ref) {
                return;
            }
            if (!this.$refs[ref]) {
                return;
            }
            this.$refs[ref].innerHTML = content;
        },
        uploadFiles() {
            if (this.$refs.editForm.validate())
            {
                this.saveLoading = true

                let formData = new FormData()

                for (let key in this.modelObject) {
                    let value = this.modelObject[key];
                    if (value instanceof File) {
                        formData.append(key, value);
                    }
                }

                var url = route('resources.upload_wallet')
                axios({
                    method: 'post',
                    url: url,
                    data: formData,
                })
                    .then(response =>
                    {
                        if (response.data.success) {
                            this.$root.is_dirty = false
                            this.$root.snackbar.success('Files have been saved')
                            this.saveLoading = false
                            this.emptyUpload()
                        } else if( response.data?.error ) {
                            throw (response.data?.error)
                        } else {
                            throw ('Unknown error.')
                        }
                    })
                    .catch((error) => {
                        this.saveLoading = false
                        this.$root.handleErrors(error)
                    })
            } else {
                this.$root.snackbar.error('Please fill all required fields.')
            }
        }
    }
}
</script>
<style scoped>
.description {
    font-size: 0.9em;
}
</style>
